/* eslint-disable */
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

const STATUS_OPTIONS = ["open", "pending", "resolved", "archived"];

function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { dateStyle:"medium", timeStyle:"short" }); }
  catch { return iso; }
}

export default function AdminSupport() {
  const [tickets, setTickets] = useState([]);
  const [stats, setStats]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState("open");
  const [active, setActive]   = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const params = filter === "all" ? "" : `?status=${encodeURIComponent(filter)}`;
      const [t, s] = await Promise.all([
        api.get(`/admin/support/tickets${params}`),
        api.get("/admin/support/stats"),
      ]);
      setTickets(t.data);
      setStats(s.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not load tickets");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const setStatus = async (ticket_id, status) => {
    try {
      await api.patch(`/admin/support/tickets/${ticket_id}`, { status });
      toast.success(`Marked ${status}`);
      setActive(null);
      load();
    } catch (e) { toast.error("Update failed"); }
  };

  return (
    <div className="m-admin-section" data-testid="support-panel">
      {/* Stat strip */}
      {stats && (
        <div className="m-stats-row m-utm-stats" style={{marginBottom:18}}>
          <div className="m-stat" data-testid="support-total"><span className="m-stat-num">{stats.total}</span><span className="m-stat-label">All tickets</span></div>
          <div className="m-stat" data-testid="support-open"><span className="m-stat-num">{stats.open}</span><span className="m-stat-label">Open</span></div>
          <div className="m-stat" data-testid="support-pending"><span className="m-stat-num">{stats.pending}</span><span className="m-stat-label">Pending</span></div>
          <div className="m-stat" data-testid="support-resolved"><span className="m-stat-num">{stats.resolved}</span><span className="m-stat-label">Resolved</span></div>
          <div className="m-stat" data-testid="support-7d"><span className="m-stat-num">{stats.last_7d}</span><span className="m-stat-label">Last 7d</span></div>
        </div>
      )}

      <div className="m-card m-utm-card">
        <div className="m-overview-h" style={{justifyContent:"space-between"}}>
          <div>
            <span className="m-eyebrow">Customer support</span>
            <h3>Tickets <em>· {filter === "all" ? "all" : filter}</em></h3>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {["open", "pending", "resolved", "archived", "all"].map(s => (
              <button
                key={s}
                className={"m-tab" + (filter === s ? " active" : "")}
                onClick={() => setFilter(s)}
                data-testid={`support-filter-${s}`}
                style={{padding:"6px 14px",fontSize:11}}
              >{s}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="m-loading-inline">Loading…</div>
        ) : tickets.length === 0 ? (
          <div className="m-muted small">No tickets in this view.</div>
        ) : (
          <table className="m-utm-table" data-testid="support-table">
            <thead><tr><th>When</th><th>From</th><th>Topic</th><th>Subject</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {tickets.map(t => (
                <tr key={t.ticket_id} data-testid={`support-row-${t.ticket_id}`}>
                  <td className="m-muted small">{fmt(t.created_at)}</td>
                  <td>{t.name}<br/><span className="m-muted small">{t.email}</span></td>
                  <td className="m-muted small">/{t.category}</td>
                  <td>{t.subject}</td>
                  <td>
                    <span className={`m-pill m-pill-${t.status}`} style={{
                      padding:"3px 9px", borderRadius:999, fontSize:11,
                      background: t.status === "open" ? "rgba(184,145,58,0.18)" :
                                  t.status === "pending" ? "rgba(27,35,64,0.10)" :
                                  t.status === "resolved" ? "rgba(60,140,80,0.16)" : "rgba(0,0,0,0.06)",
                      color: t.status === "open" ? "var(--gold)" :
                             t.status === "resolved" ? "#3c8c50" : "var(--m-text)"
                    }}>{t.status}</span>
                  </td>
                  <td><button className="m-btn-ghost" style={{padding:"5px 10px",fontSize:11}} onClick={() => setActive(t)} data-testid={`support-open-${t.ticket_id}`}>Open</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Inline detail panel */}
      {active && (
        <div className="m-card m-utm-card" data-testid="support-detail" style={{marginTop:16, border:"1px solid var(--gold)"}}>
          <div className="m-overview-h" style={{justifyContent:"space-between"}}>
            <div>
              <span className="m-eyebrow">Ticket · {active.ticket_id}</span>
              <h3>{active.subject}</h3>
            </div>
            <button className="m-btn-ghost" onClick={() => setActive(null)} style={{padding:"5px 12px",fontSize:11}}>Close</button>
          </div>

          <div className="m-overview-row">
            <div className="m-overview-col">
              <div className="m-overview-subtitle">Message</div>
              <div style={{whiteSpace:"pre-wrap", background:"#fafafa", padding:16, borderRadius:8, fontSize:14, lineHeight:1.55, marginTop:8}}>{active.message}</div>
            </div>
            <div className="m-overview-col">
              <div className="m-overview-subtitle">From</div>
              <div style={{marginBottom:14}}>
                <strong>{active.name}</strong><br/>
                <a href={`mailto:${active.email}?subject=Re:%20${encodeURIComponent(active.subject)}&body=${encodeURIComponent("Hi " + active.name.split(" ")[0] + ",\n\nThanks for reaching out to Métier. \n\n— Cam")}`} style={{color:"var(--gold)"}} data-testid="support-reply-btn">Reply via email →</a>
              </div>
              <div className="m-overview-subtitle">Meta</div>
              <table className="m-utm-table" style={{marginTop:8}}>
                <tbody>
                  <tr><td>Category</td><td className="m-muted small">{active.category}</td></tr>
                  <tr><td>Member</td><td className="m-muted small">{active.user_email || "anonymous"}</td></tr>
                  <tr><td>From page</td><td className="m-muted small" style={{wordBreak:"break-all"}}>{active.referer || "—"}</td></tr>
                  <tr><td>Submitted</td><td className="m-muted small">{fmt(active.created_at)}</td></tr>
                </tbody>
              </table>
              <div className="m-overview-subtitle" style={{marginTop:14}}>Mark as</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:8}}>
                {STATUS_OPTIONS.map(s => (
                  <button key={s}
                    className={"m-tab" + (active.status === s ? " active" : "")}
                    onClick={() => setStatus(active.ticket_id, s)}
                    data-testid={`support-set-${s}`}
                    style={{padding:"6px 12px",fontSize:11}}
                  >{s}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
